<div class="c-modal--url-replacer">
  <div>
    <p500-ui-cube-preloader *ngIf="searchOnLoading$ | async; else urlsTpl"></p500-ui-cube-preloader>
    <ng-template #urlsTpl>
      <ng-container *ngIf="urlsGroupByOffer$ | async as urlByOffer; else placeholder">
        <ng-container *ngIf="urlByOffer.size > 0; else emptyUrlList">
          <div class="search-result">
            <div *ngFor="let offerIdUrl of urlByOffer | keyvalue">
              <div class="search-result__offer-link">
                <p500-ui-icon className="text-color--primary" name="domains"></p500-ui-icon>
                <a [routerLink]="['/app/traffic-control/offers', offerIdUrl.key]" target="_blank">
                  {{ offerIdUrl.value.offer }}
                </a>
              </div>
              <div class="search-result__url-option">
                <div *ngFor="let matchedUrl of offerIdUrl.value.matchedUrl">
                  <div class="mb-5">
                    <div class="text-truncate" p500UITooltip [tooltipData]="matchedUrl.url" [longContent]="true">
                      <span [gtdUrlHighlight]="matchedUrl.url" [urlTemplate]="oldDomainControl.value"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #emptyUrlList>
          <div class="text-color text-color--gray" i18n="@@common.mathced_urls_not_found">Matched URLs not found</div>
        </ng-template>
      </ng-container>
      <ng-template #placeholder>
        <div class="text-color text-color--gray" i18n="@@offer.url_replacer_placeholder">
          Fill the first field, and system will search for all matching URLs
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
